import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createTextVNode as _createTextVNode, vModelRadio as _vModelRadio, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  id: "body",
  class: "fullwidth"
}
const _hoisted_2 = { class: "page-header" }
const _hoisted_3 = { class: "width-wrap" }
const _hoisted_4 = { class: "width-wrap" }
const _hoisted_5 = { class: "page-content section" }
const _hoisted_6 = {
  key: 0,
  class: "form-messages"
}
const _hoisted_7 = {
  key: 0,
  class: "flashmessage flash-success"
}
const _hoisted_8 = {
  key: 1,
  class: "flashmessage flash-danger"
}
const _hoisted_9 = { class: "form-body" }
const _hoisted_10 = { class: "form-field" }
const _hoisted_11 = { for: "frm-settingsForm_isNotificationEnabled" }
const _hoisted_12 = { class: "checkbox" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1)
const _hoisted_14 = {
  key: 0,
  class: "form-field"
}
const _hoisted_15 = { for: "frm-settingsForm_adSearchLayout" }
const _hoisted_16 = { class: "radiolist grid-2" }
const _hoisted_17 = { class: "radio type-icon" }
const _hoisted_18 = { class: "icon-workspace" }
const _hoisted_19 = { class: "radio type-icon" }
const _hoisted_20 = { class: "icon-workspace-2" }
const _hoisted_21 = { class: "form-footer" }
const _hoisted_22 = { class: "buttons" }
const _hoisted_23 = { class: "button button--primary" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h1", null, _toDisplayString(_ctx.$t('UserSettings.title')), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("section", _hoisted_5, [
        _createElementVNode("form", {
          id: "userProfile-form",
          class: "form",
          onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.send && _ctx.send(...args)), ["prevent"])),
          autocomplete: "off"
        }, [
          (_ctx.showFormMessages)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                (_ctx.isSuccess)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.$t('UserSettings.success-message')), 1))
                  : _createCommentVNode("", true),
                (_ctx.isError)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.$t('forms.required-fields')), 1))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors, (error, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "flashmessage flash-danger"
                  }, _toDisplayString(error), 1))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.$t('UserSettings.notifications')) + ":", 1),
              _createElementVNode("label", _hoisted_12, [
                _createTextVNode(_toDisplayString(_ctx.$t('UserSettings.notification-active')) + " ", 1),
                _withDirectives(_createElementVNode("input", {
                  name: "frm-settingsForm_isNotificationEnabled",
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.v$.form.isNotificationEnabled.$model) = $event))
                }, null, 512), [
                  [_vModelCheckbox, _ctx.v$.form.isNotificationEnabled.$model]
                ]),
                _hoisted_13
              ])
            ]),
            (!_ctx.isMobile)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.$t('UserSettings.search-layout')) + ":", 1),
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("label", _hoisted_17, [
                      _withDirectives(_createElementVNode("input", {
                        type: "radio",
                        name: "frm-settingsForm_adSearchLayout",
                        value: 1,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.v$.form.adSearchLayout.$model) = $event))
                      }, null, 512), [
                        [
                          _vModelRadio,
                          _ctx.v$.form.adSearchLayout.$model,
                          void 0,
                          { number: true }
                        ]
                      ]),
                      _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.$t('UserSettings.search-layout-option1')), 1)
                    ]),
                    _createElementVNode("label", _hoisted_19, [
                      _withDirectives(_createElementVNode("input", {
                        type: "radio",
                        name: "frm-settingsForm_adSearchLayout",
                        value: 2,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.v$.form.adSearchLayout.$model) = $event))
                      }, null, 512), [
                        [
                          _vModelRadio,
                          _ctx.v$.form.adSearchLayout.$model,
                          void 0,
                          { number: true }
                        ]
                      ]),
                      _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.$t('UserSettings.search-layout-option2')), 1)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("button", _hoisted_23, _toDisplayString(_ctx.$t('UserSettings.button-save')), 1)
            ])
          ])
        ], 32)
      ])
    ])
  ]))
}